module.exports = __webpack_public_path__ + "static/2-24f0e0fb3587f4b73397be5ca81ac467.jpg";